import request from '@/utils/request';

// 1. 开通商店
export function upDateStores(data) {
  return request({
    url: '/ajax/enterprises/' + data.eid + '/market',
    method: 'post',
    data: data
  });
}
// 1. 注册商店
export function registerStores(data) {
  return request({
    url: '/enterprise-server/market/register',
    method: 'post',
    data: data
  });
}


// 2. 修改商店信息
export function upDateStoresInfo(data) {
  return request({
    url: '/ajax/enterprises/' + data.eid + '/market',
    method: 'PUT',
    data
  });
}

// 3. 获取商店列表
export function fetchStoreList() {
  return request({
    url: '/ajax/markets',
    method: 'get'
  });
}

// 4. 获取商店客户列表
export function fetchStoreCustomersList(params = {}) {
  return request({
    url: '/ajax/enterprises/' + params.eid + '/market/customers',
    method: 'get'
  });
}

// 5. 获取企业商店信息
export function fetchStoreInfo(params) {
  return request({
    url: '/ajax/enterprises/' + params.eid + '/market',
    method: 'get'
  });
}

// 6. 获取企业商店订单管理列表
export function fetchStoreOrderList(params = {}) {
  return request({
    url: `/order-server/market/${params.marketID}/orders`,
    method: 'get',
    params: params
  });
}

// 7. 获取企业商店订单交付 发货
export function upOrderDelivery(data = {}) {
  return request({
    url: `/order-server/market/${data.marketID}/orders/${data.orderID}/delivery`,
    method: 'post',
    data: {}
  });
}

// 8. 获取商店应用管理列表
export function fetchStoreAppManageList(params = {}) {
  return request({
    url: `/app-server/markets/${params.marketID}/manageApps`,
    method: 'get',
    params: {
      page: params.page,
      pageSize: params.pageSize,
      query: params.query,
      orgID: params.orgID,
      publishType: params.publishType,
      status: params.status,
      classIDs: params.classIDs,
      templateType: params.templateType,
      appCategory: params.appCategory
    }
  });
}

// 9. 删除商店应用管理应用
export function deleteStoreAppManage(data = {}) {
  return request({
    url: `/app-server/markets/${data.marketID}/apps/${data.appID}/packages`,
    method: 'DELETE'
  });
}
// 10. 获取企业商店订单交付 发货
export function upOrderAudit(data = {}) {
  return request({
    url: `/order-server/market/${data.marketID}/orders/${data.orderID}/review`,
    method: 'post',
    data: {}
  });
}
// 10. 获取企业商店订单详情
export function fetchStoreOrderInfo(data = {}) {
  return request({
    url: `/order-server/market/${data.marketID}/orders/${data.orderID}`,
    method: 'get'
  });
}
// 10. 获取企业商店交付应用详情
export function fetchStoreDeliveryAppInfo(data = {}) {
  return request({
    url: `/delivery-server/markets/${data.marketID}/deliveryapps/${data.appID}`,
    method: 'get'
  });
}
// 10. 获取企业商店重新交付
export function fetchStoreToDelivery(data = {}) {
  return request({
    url: `/order-server/market/${data.marketID}/orders/${data.orderID}/delivery`,
    method: 'post',
    data: {}

  });
}

export function getOverviewAboutOrder(data = {}) {
  return request({
    url: `/order-server/market/${data.marketID}/overview`,
    method: 'GET'
  });
}

// 获取微信支付配置
export function getPaymentConfig(data) {
  return request({
    url: `/order-server/markets/${data.marketID}/wechat-config`,
    method: 'GET'
  });
}

// 保存或更新微信支付配置
export function putPaymentConfig(data) {
  return request({
    url: `/order-server/markets/${data.marketID}/wechat-config`,
    method: 'PUT',
    data: data
  });
}

// 上传微信支付私钥文件（.pem）
export function uploadPaymentPrivateKey(data = {}) {
  const formData = new FormData();
  formData.append('file', data.file);
  return request({
    url: `/order-server/markets/${data.marketID}/wechat-config/private-key`,
    method: 'POST',
    data: formData
  });
}

// 删除微信支付配置
export function deletePaymentConfig(data = {}) {
  return request({
    url: `/order-server/markets/${data.marketID}/wechat-config`,
    method: 'DELETE'
  });
}

// 获取微信支付公开配置（不含敏感字段）
export function getPaymentPublicConfig(data = {}) {
  return request({
    url: `/order-server/markets/${data.marketID}/wechat/public-config`,
    method: 'GET'
  });
}

// 获取商店内部配置
export function getMarketInternalConfig(data = {}) {
  return request({
    url: `/enterprise-server/markets/${data.marketID}/internal-config`,
    method: 'GET'
  });
}

// 更新商店内部配置（支持部分字段）
export function putMarketInternalConfig(data = {}) {
  const { marketID, ...payload } = data;
  return request({
    url: `/enterprise-server/markets/${marketID}/internal-config`,
    method: 'PUT',
    data: payload
  });
}



// WEBPACK FOOTER //
// ./src/api/stores.js